export default "__VITE_ASSET__ADDjYYp8__"